import { Link } from 'react-router-dom';
import type { CaseItem } from '@/types/content';
import CaseCard from '@/components/base/CaseCard';
import SectionHeading from '@/components/base/SectionHeading';

interface CaseGridProps {
  items: readonly CaseItem[];
  showAllLink?: boolean;
  eyebrow?: string;
  title?: string;
  desc?: string;
}

export default function CaseGrid({
  items,
  showAllLink = true,
  eyebrow = '事件库',
  title = '正在被讨论的吃瓜事件',
  desc = '每一个事件都已整理好关系图、时间线与当事人回应，点进去就能按脉络读完。',
}: CaseGridProps) {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20">
      <SectionHeading
        eyebrow={eyebrow}
        title={title}
        desc={desc}
        action={
          showAllLink ? (
            <Link
              to="/cases"
              className="inline-flex items-center gap-2 px-4 py-2.5 rounded-md border border-foreground-300 text-foreground-800 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap"
            >
              查看全部事件
              <i className="ri-arrow-right-line" />
            </Link>
          ) : undefined
        }
      />
      <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
        {items.map((item) => (
          <CaseCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}